// export const API_URL = 'http://localhost:3000/api';

export const API_URL = 'https://qbsfintegration.sundekapp.com/api';
